var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"com-tab"},_vm._l((_vm.tabsList),function(item,index){return _c('div',{key:index,staticClass:"com-tab-item",class:{
	      'com-tab-active': _vm.currentTab === index,
	      'com-tab-first': index === 0, 
	      'com-tab-last': index === _vm.tabsList.length - 1
	    },on:{"click":function($event){return _vm.tabsChange(index)}}},[_vm._v(" "+_vm._s(item.name)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }